import { openStudioTarget, type StudioTarget } from '../studio/studio-navigation';
export interface PhotoResultEntry {
  owner: number;
  orderId: number;
  revision: number;
  index: number;
  file: File;
  /** Ещё кадры того же заказа («Рилс», «Слайды» и наборы берут несколько снимков); первый — file */
  extra?: Array<{ index: number; file: File }>;
  destination: 'video' | 'reels' | 'infog' | (string & {});
  createdAt: number;
}
let entry: PhotoResultEntry | null = null;
/** Blob живёт только в памяти вкладки. В хранилище не записываются приватные файлы или URL.
    open — куда перейти (по умолчанию каталог: экран назначения берёт кадр из памяти сам) */
export function stagePhotoResult(value: Omit<PhotoResultEntry, 'createdAt'>, open: StudioTarget = { view: 'catalog' }) {
  entry = { ...value, createdAt: Date.now() };
  openStudioTarget(open);
  document.dispatchEvent(new CustomEvent('steos:photo:result-entry'));
}
export function readPhotoResult() {
  if (entry && Date.now() - entry.createdAt > 20 * 60 * 1000) entry = null;
  return entry;
}
export function clearPhotoResult(expected: PhotoResultEntry) {
  if (entry === expected) entry = null;
}
